import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        width: "100%",

        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
    },

    divisor: {
        display: "block",
        width: rem(32),
        height: rem(1),
        border: "none",
        backgroundColor: theme.colors.gray[4],
        margin: 0,
        opacity: "initial",
    },
}))
